/*----------------------------------
- DEPENDANCES
----------------------------------*/

import React from 'react';
import useContext from '@/client/context';

/*----------------------------------
- COMPONENT
----------------------------------*/
export default ({ isLoading }: { isLoading: boolean }) => {
    return (
        <div id="loading" class={'col al-center' + (isLoading ? ' display' : '')}>
            <i src="spin" />
        </div>
    )
}